import Vue from 'vue'
import dateFilters from './date'
import filters from './filters'
import toCase from './toCase'

Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})
Object.keys(dateFilters).forEach((key) => {
  Vue.filter(key, dateFilters[key])
})

Vue.filter('toCase', toCase)
